import { useEffect, useState } from "react";
import { getBudgetYearListData } from "@api/inventory/budgetYearListData";

export const useBudgetYearList = () => {
  const [data, setData] = useState<any>([]);

  const [query, setQuery] = useState({});

  const [refetch, setRefetch] = useState({
    refetch: false,
  });

  useEffect(() => {
    getBudgetYearListData()
      .then((data) => {
        setData(data.data);
      })
      .catch((err) => console.log(err));

    return setData([]);
  }, []);

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    if (query) {
      getBudgetYearListData(query)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [query]);

  useEffect(() => {
    if (refetch.refetch) {
      getBudgetYearListData()
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [refetch]);

  return { data, handleQuery, setQuery, setRefetch };
};
